"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateImportMapFiles = exports.generateRemoteFile = exports.generateIndexFile = exports.removeAllFiles = exports.getImportMapFileBy = exports.getImportMapNameBy = void 0;
var mfe_1 = require("../mfe");
function getImportMapNameBy(fileFolder) {
    return (fileFolder &&
        fileFolder.length > 0 &&
        fileFolder
            .split("-")
            .map(function (e) { return e.toUpperCase(); })
            .join("_") + "_IMPORT_MAP");
}
exports.getImportMapNameBy = getImportMapNameBy;
function getImportMapFileBy(fileFolder) {
    return (fileFolder &&
        fileFolder.length > 0 &&
        fileFolder.replace(/-([a-zA-Z])/g, function (k) {
            return k[1].toUpperCase();
        }) + "ImportMap");
}
exports.getImportMapFileBy = getImportMapFileBy;
function removeAllFiles(_a, dirPath) {
    var fs = _a.fs;
    fs.readdirSync("".concat(dirPath, "/types")).forEach(function (file) {
        return fs.rmSync("".concat(dirPath, "/types/").concat(file));
    });
    fs.readdirSync(dirPath).forEach(function (file) {
        if (file != "types") {
            fs.rmSync("".concat(dirPath, "/").concat(file));
        }
    });
    return true;
}
exports.removeAllFiles = removeAllFiles;
function generateIndexFile(_a, dirPath) {
    var fs = _a.fs;
    var fileFolders = Object.values(mfe_1.MFE_GENERAL_SETTINGS).map(function (settings) { return settings.fileFolder; });
    var fileContent = "// DO NOT CHANGE THIS FILE! IT IS AN AUTO-GENERATED FILE WITH \"npm run generate-import-map\" \n\n" +
        "import { CommonMFE } from \"@tpd-web-common-libs/nodejs-library\";\n" +
        fileFolders
            .map(function (fileFolder) {
            return "import { ".concat(getImportMapNameBy(fileFolder), " } from \"./").concat(getImportMapFileBy(fileFolder), "\";\n");
        })
            .join("") +
        "\n" +
        "const IMPORT_REMOTES_MAP: CommonMFE.Types.TRemotesMap = {\n" +
        fileFolders
            .map(function (fileFolder) {
            return "  ...".concat(getImportMapNameBy(fileFolder), ",\n");
        })
            .join("") +
        "};\n\n" +
        "export default IMPORT_REMOTES_MAP;";
    fs.writeFile(dirPath + "/index.ts", fileContent, function (err) {
        if (err)
            throw err;
        console.log("index Saved!");
    });
}
exports.generateIndexFile = generateIndexFile;
function generateRemoteFile(_a, dirPath, isHCLEnvironment, mfeType) {
    var fs = _a.fs;
    var fileFolder = mfe_1.MFE_GENERAL_SETTINGS[mfeType].fileFolder;
    var mfeSettings = mfe_1.MFE_GENERAL_SETTINGS[mfeType].mfeSettings;
    var fileName = "".concat(dirPath, "/").concat(getImportMapFileBy(fileFolder), ".ts");
    var mfeSettingsValues = Object.values(mfeSettings).filter(function (mfeSetting) {
        return !isHCLEnvironment || !mfeSetting.skipImportingInCMS;
    });
    var fileContent = "// DO NOT CHANGE THIS FILE! IT IS AN AUTO-GENERATED FILE WITH \"npm run generate-import-map\" \n\n" +
        "import { CommonMFE, MFE_NAMES } from \"@tpd-web-common-libs/nodejs-library\";\n\n" +
        "export const ".concat(getImportMapNameBy(fileFolder), ": CommonMFE.Types.TRemotesMap = {\n") +
        mfeSettingsValues
            .map(function (mfeSetting) {
            return ("  [MFE_NAMES.".concat(mfeSetting.__mfeName__, "]: {\n") +
                "    import: () => import(\"".concat(mfeSetting.__mfeName__, "/bootstrap\"),\n") +
                "  },\n");
        })
            .join("") +
        "};";
    fs.writeFile(fileName, fileContent, function (err) {
        if (err)
            throw err;
        console.log("".concat(fileName, " Saved!"));
    });
    var fileTypeName = "".concat(dirPath, "/types/").concat(getImportMapFileBy(fileFolder), ".d.ts");
    var fileTypeContent = "// DO NOT CHANGE THIS FILE! IT IS AN AUTO-GENERATED FILE WITH \"npm run generate-import-map\" \n\n" +
        mfeSettingsValues
            .map(function (mfeSetting) {
            return "declare module \"".concat(mfeSetting.__mfeName__, "/bootstrap\";\n");
        })
            .join("");
    fs.writeFile(fileTypeName, fileTypeContent, function (err) {
        if (err)
            throw err;
        console.log("".concat(fileTypeName, " Saved!"));
    });
    return true;
}
exports.generateRemoteFile = generateRemoteFile;
function generateImportMapFiles(dirPath, isHCLEnvironment, __deps__) {
    removeAllFiles(__deps__, dirPath);
    generateIndexFile(__deps__, dirPath);
    Object.values(mfe_1.MFE_TYPES).forEach(function (mfeType) {
        generateRemoteFile(__deps__, dirPath, isHCLEnvironment, mfeType);
    });
}
exports.generateImportMapFiles = generateImportMapFiles;
